package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.screens.mikud.MikudRepository

class ExtractMikudListUseCase {

    operator fun invoke(chapterList: String): List<String> =
        chapterList                                                             // 31_ruth-[,01,02,03,04]
            .substringAfter(MikudRepository.DASH)                               // [,01,02,03,04]
            .removeSurrounding(prefix = "[", suffix = "]")                      // ,01,02,03,04
            .split(",")
            .filter { it.isNotEmpty() }
}
